import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { FacebookLoginButton } from '@stepstone/social-auth-components';
import { isFacebookEnabledSelector } from '../../../core/siteConfig/siteConfigSlice.js';
import { useSendFacebookTrackingScript } from '../../../../tracking/featureSpecific/facebook/index.js';
import { clearAuthError } from '../../../core/authError/authErrorSlice.js';
import { setErrorStatus, setShowRegistrationSuccessfulModal, } from '../../../../views/Registration/registrationSlice.js';
import { INITIAL_TRACKING_DELAY } from '../../../../tracking/constants.js';
import { useAppDispatch, useAppSelector } from '../../../hooks.js';
import { authSuccessThunk } from '../../../core/authSuccess/authSuccessSlice.js';
import { useTrack } from '../../../../tracking/common/hooks/useTrack.js';
export const FacebookButton = ({ buttonText }) => {
    const isFacebookEnable = useAppSelector(isFacebookEnabledSelector);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { trackBtnClick } = useTrack('twoStep');
    const handleFacebookLoginError = () => {
        dispatch(setErrorStatus(401));
    };
    const handleFacebookLoginSuccess = async ({ accountWasCreated, }) => {
        if (accountWasCreated) {
            setTimeout(() => {
                dispatch(setShowRegistrationSuccessfulModal(true));
            }, INITIAL_TRACKING_DELAY);
        }
        else {
            await dispatch(authSuccessThunk('facebook', 200));
        }
    };
    const { setTrackingEventState } = useSendFacebookTrackingScript('login');
    const sentTrackingCallbackHandler = (action) => {
        /*
          there is no way of catching facebook button click,
          so using this workaround to clear auth errors on click
        */
        if (action === 'buttonClick') {
            dispatch(clearAuthError());
            trackBtnClick({ uniqueName: 'facebook' });
        }
        setTrackingEventState(action);
    };
    return isFacebookEnable ? (_jsx(FacebookLoginButton, { a11yLabel: t('loginregistration.login.facebookButton.a11yLabel'), buttonText: buttonText || t('loginregistration.login.facebookButton'), onSuccess: handleFacebookLoginSuccess, onError: handleFacebookLoginError, onSendTrackingCallback: sentTrackingCallbackHandler })) : null;
};
//# sourceMappingURL=FacebookButton.js.map